var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('router-link',{staticClass:"logo-link",attrs:{"to":"/"}},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/logo.png")}})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }